import axiosInstance from './axios'

import {
  InfoApiClient,
  ApiKeysApiClient,
  LicensesApiClient,
  JokesApiClient,
  MediaApiClient,
  MiyuImagesApiClient,
  QuestionsApiClient,
  AuthenticationApiClient,
} from '@/api/codegen'

const envBase = import.meta.env.VITE_TEAM_QUANTUM_API_URL as string | undefined
const BASE_PATH = envBase ?? 'http://localhost:5000'

// api
const authApi = new AuthenticationApiClient(BASE_PATH, axiosInstance)
const infoApi = new InfoApiClient(BASE_PATH, axiosInstance)
const apiKeysApi = new ApiKeysApiClient(BASE_PATH, axiosInstance)

// customers
const licensesApi = new LicensesApiClient(BASE_PATH, axiosInstance)

// general
const mediaApi = new MediaApiClient(BASE_PATH, axiosInstance)

// miyu bot
const miyuMediaApi = new MiyuImagesApiClient(BASE_PATH, axiosInstance)
const jokesApi = new JokesApiClient(BASE_PATH, axiosInstance)
const questionsApi = new QuestionsApiClient(BASE_PATH, axiosInstance)


export {
  infoApi,
  authApi,
  apiKeysApi,
  licensesApi,
  jokesApi,
  mediaApi,
  miyuMediaApi,
  questionsApi,
}